module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      William Heffernan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("William Heffernan began his career as a reporter for the New York "), _c('I', [_vm._v("Daily News")]), _vm._v(" and was nominated three times for the Pulitzer Prize for his work there. He also received the Robert F. Kennedy Journalism Award. Since his leap to novels, Heffernan has written eighteen books, including the Edgar Award–winning "), _c('I', [_vm._v("Tarnished Blue")]), _vm._v(" in the Paul Devlin series. Heffernan lives on the Florida Suncoast."), _c('BR')], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/8XlfIj/tc-custom/9780062028976.jpg?1718282660118",
      "alt": "This image is the cover for the book Red Angel, The Paul Devlin Mysteries"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Red Angel, The Paul Devlin Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Anyone who brings grief to the people NYPD detective Paul Devlin loves is going to have to pay. That's why he's accompanying Adrianna Mendez, the lady of his heart, to Cuba, where Adrianna's aunt Maria has met with a serious \"accident.\" A great hero of Castro's revolution, revered throughout the island as "), _c('i', [_vm._v("Angel Rojo")]), _vm._v(", Dr. Maria Mendez was burned beyond recognition in a car wreck, then her body was stolen by members of a bloodthirsty voodoo sect. Now Devlin is determined to recover the Red Angel's remains and unravel the dark secret behind her death. But the New York cop's legendary street sense may not be enough to keep him breathing in this unfamiliar world of corruption, terror, and potent black magic -- especially when a vengeful madman and his killers land on the enigmatic island with one immediate goal: to watch Paul Devlin die.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins Publishers Ltd\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0